import React from "react";
import "./DigiHero.css"; // Import CSS for styling

const DigiHero = () => {
  return (
    <div className="digihero-container">
      <img
        src="assets/golddigi.png"
        alt="Digi Hero"
        className="digihero-image"
      />
    </div>
  );
};

export default DigiHero;
